import { ComponentProps, FC, PropsWithChildren, memo } from 'react'
import { getAiAssistantAvatarUrl } from '@crew/utils/avatar'
import { CrewAvatar } from '../crewAvatar/crewAvatar'

type Props = PropsWithChildren<
  Omit<ComponentProps<typeof CrewAvatar>, 'hideTooltip' | 'displayName' | 'cacheValue'>
>

export const CrewAiAssistantAvatar: FC<Props> = memo((props) => {
  // AIアシスタントのアバター画像URL
  const imageUrl = getAiAssistantAvatarUrl()

  return (
    <CrewAvatar
      {...props}
      imageURL={imageUrl}
      displayName={''}
      cacheValue={''}
      hideTooltip
    />
  )
})
